export default __webpack_public_path__ + "static/6908-d633af1aa3379d2bb5c4a226b073a293.jpg";